import React from 'react';
import { SelectQuestion } from './SelectQuestion';
import { RadioQuestion } from './RadioQuestion';
import { NumberQuestion } from './NumberQuestion';
import { CheckboxQuestion } from './CheckboxQuestion';
import { RatingQuestion } from './RatingQuestion';
import { TextQuestion } from './TextQuestion';
import { SortableQuestion } from './SortableQuestion';

export function QuestionRenderer({ question, value, onChange, allAnswers }) {
  switch (question.type) {
    case 'select':
      return <SelectQuestion question={question} value={value} onChange={onChange} allAnswers={allAnswers} />;
    case 'radio':
      return <RadioQuestion question={question} value={value} onChange={onChange} allAnswers={allAnswers} />;
    case 'number':
      return <NumberQuestion question={question} value={value} onChange={onChange} allAnswers={allAnswers} />;
    case 'text':
    case 'email':
    case 'tel':
    case 'url':
      return <TextQuestion question={question} value={value} onChange={onChange} allAnswers={allAnswers} />;
    case 'checkbox':
      return <CheckboxQuestion question={question} value={value} onChange={onChange} allAnswers={allAnswers} />;
    case 'rating':
      return <RatingQuestion question={question} value={value} onChange={onChange} allAnswers={allAnswers} />;
    case 'sortable':
      return <SortableQuestion question={question} value={value} onChange={onChange} allAnswers={allAnswers} />;
    default:
      return null;
  }
}
